export class AuthConfig {
  tenantId!: string;
  clientId!: string;
  apiEndpoint!: string;
}
